var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar"},[_c('div',{staticClass:"top-message ell_one"},[_vm._v("\n    欢迎您,"+_vm._s(_vm.userName)+"!\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }